<div class="appfeed">
    <div *ngIf="isShowChatQuestion" class="feed-entry">
        <div class="appfeed-row">
            <div class="appfeed-icon appfeed-cell">
                <mat-icon matTooltip="Ask any question" class="material-symbols-outlined attention-success">
                    help
                </mat-icon>
            </div>
            <div class="appfeed-messagetext appfeed-cell">
                <input matInput name="chatQuestion" (keydown)="handleKeyDown($event)" [(ngModel)]="chatQuestion" />
            </div>
        </div>
    </div>
    <div class="feed-entry" *ngFor="let message of dataSource">
        <div [ngClass]="['appfeed-row', 
                         message.MessageSeverity == severities.Info ? 'appfeed-row-info' : '', 
                         message.MessageSeverity == severities.Warning ? 'appfeed-row-warning' : '',
                         message.MessageSeverity == severities.Error ? 'appfeed-row-error' : '',
                         message.MessageSeverity == severities.Success ? 'appfeed-row-success' : '']"
             (click)="showMessage(message)">
            <div class="appfeed-icon appfeed-cell">
                <mat-icon *ngIf="message.MessageSeverity == severities.Success" matTooltip="{{ message.MessageDateTime }}" class="material-symbols-outlined attention-success">
                    thumb_up
                </mat-icon>
                <mat-icon *ngIf="message.MessageSeverity == severities.Info" matTooltip="{{ message.MessageDateTime }}" class="material-symbols-outlined attention-info">
                    info
                </mat-icon>
                <mat-icon *ngIf="message.MessageSeverity == severities.Warning" matTooltip="{{ message.MessageDateTime }}" class="material-symbols-outlined attention-warning">
                    warning
                </mat-icon>
                <mat-icon *ngIf="message.MessageSeverity == severities.Error" matTooltip="{{ message.MessageDateTime }}" class="material-symbols-outlined attention-error">
                    dangerous
                </mat-icon>
            </div>
            <div class="appfeed-messagetext appfeed-cell">
                {{message.MessageText}}
            </div>
        </div>
    </div>
</div>
